import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { renameReport } from "../api/preflight.api";
import { patchReportInCaches } from "../lib/report-cache";
import type { PreflightReportSummary } from "../types/preflight.types";

export function useRenameReport(
  report: Pick<PreflightReportSummary, "id" | "name">,
) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (nextName: string) => renameReport(report.id, nextName.trim()),
    onMutate: (nextName) => {
      const previousName = report.name;
      patchReportInCaches(queryClient, report.id, { name: nextName.trim() });
      return { previousName };
    },
    onError: (_error, _vars, context) => {
      if (context) {
        patchReportInCaches(queryClient, report.id, {
          name: context.previousName,
        });
      }
      toast.error(t("preflight.toast.renameError"));
    },
    onSuccess: () => {
      toast.success(t("preflight.toast.renamed"));
    },
    meta: { skipGlobalError: true },
  });
}
